import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import { languageHelper } from "../../../../config/helperFunctions";



function DetailedShiftReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },

    {
      header: languageHelper("Date") || "Date",
      accessorKey: "Date",
      cell: (row) => row.row.original.date.split(" ")[0],
    },
    {
      header: languageHelper("Time") || "Time",
      accessorKey: "time",
    },
    {
      header: languageHelper("Reference") || "Reference",
      accessorKey: "reference",
    },
    {
      header: languageHelper("Order Type") || "Order Type",
      accessorKey: "order_type",
    },
    {
      header: languageHelper("Total Item") || "Total Item",
      accessorKey: "total_items",
    },
    {
      header: languageHelper("Subtotal") || "Subtotal",
      accessorKey: "subtotal",
      cell: (row) => (row.getValue() || 0).toFixed(2),
    },
    {
      header: languageHelper("Discount") || "Discount",
      accessorKey: "discount",
      cell: (row) => (row.getValue() || 0).toFixed(2),
    },
    {
      header: languageHelper("Service/Delivery Charges") || "Service/Delivery Charges",
      accessorKey: "service_delivery_charge",
      cell: (row) => (row.getValue() || 0).toFixed(2),
    },
    {
      header: languageHelper("Vat") || "Vat",
      accessorKey: "vat",
      cell: (row) => (row.getValue() || 0).toFixed(2),
    },
    {
      header: languageHelper("G. Total") || "G. Total",
      accessorKey: "grand_total",
      cell: (row) => (row.getValue() || 0).toFixed(2),
    },
    {
      header: languageHelper("Payment Method") || "Payment Method",
      accessorKey: "payment_method",
    },
  ];
  const footerConfig = {
    SN: languageHelper("Total") || "Total",
    "Total Item": (rows) =>
      rows.reduce((acc, row) => acc + (row.total_items || 0), 0),
    Subtotal: (rows) =>
      rows.reduce((acc, row) => acc + (row.subtotal || 0), 0).toFixed(2),
    Discount: (rows) =>
      rows.reduce((acc, row) => acc + (row.discount || 0), 0).toFixed(2),
    Vat: (rows) =>
      rows.reduce((acc, row) => acc + (row.vat || 0), 0).toFixed(2),
    "G. Total": (rows) =>
      rows.reduce((acc, row) => acc + (row.grand_total || 0), 0).toFixed(2),
  };
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [error, setError] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [selectedPayment, setSelectedPayment] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const handleUserSelect = (e) => {
    setSelectedUser(e.value);
  };
  const handlePaymentSelect = (e) => {
    setSelectedPayment(e.value);
  };

  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };

  const selectButton = [
    {
      placeholder: languageHelper("User"),
      options: users,
      onChange: handleUserSelect,
    },

    {
      placeholder: languageHelper("Payment Method"),
      options: paymentMethods,
      onChange: handlePaymentSelect,
    },
  ];

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/detailed-shift-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          user_id: selectedUser,
          payment_method: selectedPayment,
          from: startDate,
          to: endDate,
        },
      })
      .then((res) => {
        setData(res.data.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [
    endDate,
    selectedPayment,
    selectedUser,
    startDate,
    selectedOutlet,
    user?.token,
    user?.user.outlet_id,
  ]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/user`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedCustomers = res.data.map((user) => ({
          value: user.id,
          label: user.name,
        }));
        setUsers(mappedCustomers);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
    axios
      .get(`${apiKey}/api/rms/admin/payment_methods`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedPayments = res.data.map((payment) => ({
          value: payment.name,
          label: payment.name,
        }));
        setPaymentMethods(mappedPayments);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [user?.token, user?.user.outlet_id]);

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Detailed Shift Report")}
        selectButton={selectButton}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        downloads={true}
        dateTime={true}
        handleOutletSelect={handleOutletSelect}
        showFooter={true}
        footerConfig={footerConfig}
        error={error}
      />
    </main>
  );
}

export default DetailedShiftReport;
